// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__13mmV","title":"Header_title__1fiqh","left":"Header_left__2bSur","clinicName":"Header_clinicName__344XT"};